


























































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { IAssessment } from "../store/main.interfaces";
import { isAssessmentFeasable } from "../store/assessment.util";
import { NoneFeasabilityResult } from "../store/assessment.calc";

export enum Action {
  OPEN_QUICK_ASSISTANT = "openQuickAssistant"
}

@Component
export default class ImplementationMotivator extends Vue {
  @Prop({ default: () => null }) assessments!: IAssessment[];

  get isAnAssessmentAlreadyImplemented(): boolean {
    return this.assessments.find(a => a.implemented === true) != null;
  }

  get validAssessments(): IAssessment[] {
    return this.assessments.filter(isAssessmentFeasable);
  }

  get totalNumberOfValidAssessments(): number {
    return this.validAssessments.length;
  }

  get validAssessmentsExist(): boolean {
    return this.totalNumberOfValidAssessments > 0;
  }

  get totalFreedCapacity(): number {
    let sum = 0;
    this.validAssessments.forEach(a => {
      sum += a.outputs.bandwidthFreed || 0;
    });

    return Math.floor(sum);
  }

  openQuickAssistant() {
    this.cta(Action.OPEN_QUICK_ASSISTANT);
  }

  @Emit()
  cta(action: Action) {
    return action;
  }
}
